import React, { useEffect, useState } from "react";
import { getNewsInner } from '../Service/Api';
import Header from '../Component/Header'
import { Link } from 'react-router-dom' 
import LazyLoad from 'react-lazyload';
import Footer from'../Component/Footer'
const News = () => {
     useEffect(() => {
        document.title = 'News -  St Peters convent School Faridabad Haryana';  
    }, []); 
    const [data, setData] = useState([]);
    const [filterData, setFilteredData] = useState([]);
    const [selectedYear, setSelectedYear] = useState("All");
    const [selectedMonth, setSelectedMonth] = useState("All");
    const [yearRanges, setYearRanges] = useState([]);
    const [monthOptions, setMonthOptions] = useState(["All"]);
    const [searchQuery, setSearchQuery] = useState("");
    
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth();
    
    useEffect(() => {
        const fetchData = async () => {
            const galleryData = await getNewsInner(); 
            
            setData(galleryData);
    
            // Get unique years from events (sorted in ascending order)
            const uniqueYears = Array.from(new Set(galleryData.map((item) => item.fromDate ? new Date(item.fromDate).getFullYear() : null).filter(Boolean)));
            uniqueYears.sort((a, b) => a - b);
            setYearRanges(["All", ...uniqueYears.map(year => `${year}`)]);
    
            // Get unique months
            const uniqueMonths = Array.from(new Set(galleryData.map((item) => item.fromDate ? new Date(item.fromDate).getMonth() : null).filter(Boolean)));
            const sortedMonths = uniqueMonths.sort((a, b) => a - b).map(month => monthNames[month]);
            setMonthOptions(["All", ...sortedMonths]);
        };
        fetchData();
    }, []);
    
    useEffect(() => {
        let filteredData = [...data];
    
        // Filter by selected year
        if (selectedYear !== "All") {
            filteredData = filteredData.filter((item) => {
                if (item.fromDate) {
                    const year = new Date(item.fromDate).getFullYear();
                    return parseInt(selectedYear) === year;
                }
                return false;
            });
        }
    
        // Filter by selected month
        if (selectedMonth !== "All") {
            filteredData = filteredData.filter((item) => {
                if (item.fromDate) {
                    const month = new Date(item.fromDate).getMonth();
                    return monthNames[month] === selectedMonth;
                }
                return false;
            });
        }
    
        // Search filter
        if (searchQuery) {
            filteredData = filteredData.filter((item) =>
                item.title.toLowerCase().includes(searchQuery.toLowerCase())
            );
        }
    
        // Separate current month events from others
        const currentMonthEvents = filteredData.filter((item) => {
            if (item.fromDate) {
                const eventDate = new Date(item.fromDate);
                return eventDate.getFullYear() === currentYear && eventDate.getMonth() === currentMonth;
            }
            return false;
        });
    
        // Remaining events sorted in ascending order (earliest events first)
        const otherEvents = filteredData.filter((item) => !currentMonthEvents.includes(item));
        otherEvents.sort((a, b) => new Date(a.date) - new Date(b.date));
    
        // Combine: Current month events first, then all others in ascending order
        setFilteredData([...currentMonthEvents, ...otherEvents]);
    }, [data, selectedYear, selectedMonth, searchQuery]);
  return (
    <>
    <Header/>
    <div className="innerslide">
    <ul className="breadcrumb">
     <li><Link to="/"> Home</Link> </li>  
     <li>News </li>
 </ul>
</div>
<div className="innersec">
<div className="container">
     <div className="row">
           <div className="col-lg-12">
              <h1>News  </h1>
         </div>
     </div>
     <div className="row tabs-dynamic">
     <div className="col-xxl-3 col-xl-3 col-lg-6 col-12">
         <div className="count-val">
             <p>Total Count: {filterData.length} </p>
         </div>
     </div>
     <div className="col-xxl-3 col-xl-3 col-lg-6 col-12">
         <div className="month-selection">
             <select
                 value={selectedYear}
                 onChange={(e) => setSelectedYear(e.target.value)}
                 className="yearSelection">
                 
                 {yearRanges.map((yr) => (
                     <option key={yr} value={yr}>{yr}</option>
                 ))}
             </select>
         </div>
     </div>
     <div className="col-xxl-3 col-xl-3 col-lg-6 col-12">
         <div className="month-selection">
             <select
                 value={selectedMonth}
                 onChange={(e) => setSelectedMonth(e.target.value)}
                 className="monthSelect">
                 {monthOptions.map((month, index) => (
                     <option key={index} value={month}>{month}</option>
                 ))}
             </select>
         </div>
     </div>
     <div className="col-xxl-3 col-xl-3 col-lg-6 col-12">
         <div className="searchBox">
             <input
                 type="text"
                 id="myInput"
                 name="name"
                 value={searchQuery}
                 onChange={(e) => setSearchQuery(e.target.value)}
                 placeholder="Search Here.."
             />
         </div>
     </div>
 </div>
 <div className="row years year2023 showYear">
     {filterData.length > 0 &&
         filterData.map((item, index) => (
             <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 eventCount" key={index}>
                 <div className="eventbox">
                     <div className="eventboximg">
                     {item.attachments && item.attachments.length > 0 && (
                        <div className="eventattch">
                          {item.attachments.map((attachment, index) => (
                            <a
                              key={index}
                              href={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${attachment}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{ marginRight: '8px' }} // Optional spacing between icons
                            >
                              <i className="bi bi-paperclip"></i>
                            </a>
                          ))}
                        </div>
                      )}
                      
                     <LazyLoad>
                     {item?.image.length > 0 ? (
                       <a
                         data-magnify="gallery"
                         data-src={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${item.image[0]}`}
                         data-group="a"
                         href={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${item.image[0]}`}
                       >
                         <img
                           src={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${item.image[0]}`}
                           alt="Gallery"
                           className="img-fluid"
                         />
                       </a>
                     ) : (
                       <a
                         data-magnify="gallery"
                         data-src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/news.jpg"
                         data-group="a"
                         href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/news.jpg"
                       >
                         <img
                           src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/news.jpg"
                           alt="Gallery Placeholder"
                           className="img-fluid"
                         />
                       </a>
                     )}
                   </LazyLoad>   </div>
                     <div className="eventboxdesc">
                         <div className="eventpgh">
                             <h5>{item.title}</h5>
                             <p>{item.description}</p>
                         </div>
                         <div className="eventdate">
                         <span><i className="bi bi-calendar"></i> {item.fromDate}</span>
                             <span><i className="bi bi-alarm"></i>{item.time}</span>
                             
                             <span><i className="bi bi-geo-alt"></i> {item.venue} </span>
                         </div>
                     </div>
                 </div>
             </div>
         ))}
     </div>
  </div>
</div>
<Footer/>
    </>
  )
}

export default News
